import Axios from "axios"
import qs from 'qs'
import config from "./config"
let url = config.url;

//获取批次
export function getBatchList(module) {
  const data = qs.stringify({
    m: "studentEnrollApi",
    t: "studentEnrollApi",
    c: "batchList",
    sfzjh: module.sfzjh,
  });
  return Axios.post(url, data).then(res => {
    return Promise.resolve(res.data)
  })
}
//登录按钮，登录事件
export function login(module) {
  const data = qs.stringify({
    m: "studentEnrollApi",
    t: "studentEnrollApi",
    c: "login",
    sfzjh: module.sfzjh,
    xm: module.xm,
    batch_id: module.batch_id,
  });
  return Axios.post(url, data).then(res => {
    return Promise.resolve(res.data)
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js